import { PaymentTaskExpenseAccountItem } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2360. 支払タスク費用科目追加
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_expense_account_items
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  expense_account_item_id: number;
  amount: number;
};
const createPaymentTaskExpenseAccountItem = (props: Props): Promise<PaymentTaskExpenseAccountItem> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_expense_account_items`,
    props
  );
};

export const useCreatePaymentTaskExpenseAccountItem = () => {
  return useMutation({
    mutationFn: createPaymentTaskExpenseAccountItem,
  });
};
